import CareerStatusInfo from "./career-status-info";
import CareerStatusProgress from "./career-status-progress";
import { CareerStatusContainer } from "./styled-components";

const CareerStatus = () => (
  <CareerStatusContainer>
    <CareerStatusInfo />
    <CareerStatusProgress />
  </CareerStatusContainer>
);

export default CareerStatus;
